import './ActivityResultStates.scss';

import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { Stack } from '~shared/components/Stack';
import { useSocrativeRouter } from '~teacher/context/RouterContext';

export const ActivityResultBlankResults = () => {
  const router = useSocrativeRouter();
  return (
    <div className="w-full flex flex-col justify-center items-center activity-result-states-container">
      <svg width="180" height="180">
        <g fill="none">
          <path d="M0 0h180v180H0z" />
          <path
            d="M123.58 11c7.5 0 14.42 4 18.16 10.49L174.94 79a21.01 21.01 0 010
            20.98l-33.2 57.52A20.96 20.96 0 01123.58 168h-66.4c-7.5 0-14.42-4-18.16-10.49L5.82
            100a20.97 20.97 0 010-20.98l33.2-57.52A20.96 20.96 0 0157.18 11h66.4zm-69 93.9h-.56l-1.12.03c-.76.02-1.52.03-2.32-.03a4.02 4.02
            0 00-3.6 3.8v4.2a4 4 0 004.4 4c1-.1 2.1-.1 3.1-.1 14.2 0 26.6 8.2 32.6 20.1a4.06 4.06 0 005.4 1.8l.2-.1 3.5-2c1.9-1 2.6-3.4 1.6-5.3-8-15.7-24.4-26.4-43.2-26.4zm0-30h-.52l-.52.02-1.6.06-1.16.02a4
            4 0 00-3.9 3.8V83a4 4 0 004.2 4c1.1-.1 2.2-.1 3.3-.1 25.4 0 47.5 14.3 58.7 35.2a4.1 4.1 0 005.4 1.7l.2-.1 3.5-2c1.9-1 2.6-3.4 1.6-5.3a78.35 78.35 0 00-69.2-41.5zm0-31c-.96 0-1.92 0-2.88.05l-.93.06a3.98
            3.98 0 00-3.69 3.79V52a4 4 0 004.2 4c1.1-.1 2.2-.1 3.3-.1 36.9 0 69.1 20.5 85.6 50.8a4.02 4.02 0 005.32 1.7l.18-.1 3.5-2c1.9-1.1 2.5-3.5 1.5-5.4-18.6-34-54.7-57-96.1-57z"
            fill="#EFF3F5"
          />
        </g>
      </svg>
      <div className="px-8 pt-12 max-w-3xl">
        <Stack space="8" align="center">
          <span className="font-display text-md font-500 text-blue-900">
            {translate('Live Results')}
          </span>
          <p className="font-sans text-base leading-8 text-blue-900 text-center">
            {translate(
              "You'll see live results for your room's current activity here. Launch a new activity to get started!"
            )}
          </p>
          <UIButton
            onClick={() => {
              router.routeToLaunch();
            }}
          >
            {translate('Launch Activity')}
          </UIButton>
        </Stack>
      </div>
    </div>
  );
};
